const REVEAL_CLASS = 'lay-typewriter-bg-reveal'
const REVEAL_ATTR = 'data-lay-typewriter-bg-reveal'
const OVERLAY_CLASS = 'lay-typewriter-bg-reveal-overlay'
const targetStates = new WeakMap()

function hasPaintedBackground(el) {
	if (!el || !window.getComputedStyle) {
		return false
	}
	const cs = window.getComputedStyle(el)
	const bgColor = cs.backgroundColor
	const bgImage = cs.backgroundImage
	return (bgImage && bgImage !== 'none') || (bgColor && bgColor !== 'transparent' && bgColor !== 'rgba(0, 0, 0, 0)')
}

function findBackgroundRevealContainer(unit, target) {
	let el = unit
	while (el && el !== target) {
		if (el.nodeType === Node.ELEMENT_NODE && hasPaintedBackground(el)) {
			return el
		}
		el = el.parentElement
	}
	return null
}

function resetContainer(container, reverse) {
	container.classList.add(REVEAL_CLASS)
	container.setAttribute(REVEAL_ATTR, '1')
	container.style.clipPath = reverse ? 'inset(0 0 0 100%)' : 'inset(0 100% 0 0)'
	container.style.webkitClipPath = container.style.clipPath
}

function setContainerClip(container, clipPath) {
	container.classList.add(REVEAL_CLASS)
	container.setAttribute(REVEAL_ATTR, '1')
	container.style.clipPath = clipPath
	container.style.webkitClipPath = clipPath
}

function clearContainerClip(container) {
	container.classList.remove(REVEAL_CLASS)
	container.removeAttribute(REVEAL_ATTR)
	container.style.clipPath = ''
	container.style.webkitClipPath = ''
}

function restoreContainerBackground(state) {
	if (!state || !state.originalStyle) {
		return
	}
	const container = state.container
	container.style.backgroundColor = state.originalStyle.backgroundColor
	container.style.backgroundImage = state.originalStyle.backgroundImage
	container.style.position = state.originalStyle.position
	container.style.zIndex = state.originalStyle.zIndex
	if (state.overlay && state.overlay.parentNode) {
		state.overlay.parentNode.removeChild(state.overlay)
	}
	state.overlay = null
	state.lines.forEach((line) => {
		line.overlay = null
	})
}

function clearState(state) {
	if (!state || !state.containers) {
		return
	}
	if (state.states) {
		state.states.forEach((containerState) => restoreContainerBackground(containerState))
	}
	state.containers.forEach((container) => {
		clearContainerClip(container)
	})
	if (state.targetPositionChanged && state.target) {
		state.target.style.position = state.originalTargetPosition
	}
}

function getUnitRightInContainer(unit, container) {
	const unitRect = unit.getBoundingClientRect()
	const containerRect = container.getBoundingClientRect()
	return Math.max(0, Math.min(containerRect.width, unitRect.right - containerRect.left))
}

function getUnitLeftInContainer(unit, container) {
	const unitRect = unit.getBoundingClientRect()
	const containerRect = container.getBoundingClientRect()
	return Math.max(0, Math.min(containerRect.width, unitRect.left - containerRect.left))
}

function measureVisualLines(units, container) {
	const cs = window.getComputedStyle(container)
	const paddingTop = parseFloat(cs.paddingTop) || 0
	const paddingRight = parseFloat(cs.paddingRight) || 0
	const paddingBottom = parseFloat(cs.paddingBottom) || 0
	const paddingLeft = parseFloat(cs.paddingLeft) || 0
	const lines = []
	const unitLines = new Map()

	units.forEach((unit) => {
		const unitRect = unit.getBoundingClientRect()
		let line = lines.find((entry) => Math.abs(entry.anchorTop - unitRect.top) <= 1)

		if (!line) {
			line = {
				anchorTop: unitRect.top,
				top: unitRect.top,
				bottom: unitRect.bottom,
				left: unitRect.left,
				right: unitRect.right,
				units: [],
			}
			lines.push(line)
		} else {
			line.top = Math.min(line.top, unitRect.top)
			line.bottom = Math.max(line.bottom, unitRect.bottom)
			line.left = Math.min(line.left, unitRect.left)
			line.right = Math.max(line.right, unitRect.right)
		}
		line.units.push(unit)
	})

	lines.sort((a, b) => a.top - b.top)
	lines.forEach((line, index) => {
		line.index = index
		line.paintTop = line.top - paddingTop
		line.paintBottom = line.bottom + paddingBottom
		line.paintLeft = line.left - paddingLeft
		line.paintRight = line.right + paddingRight
		line.paddingLeft = paddingLeft
		line.paddingRight = paddingRight
		line.units.forEach((unit) => unitLines.set(unit, line))
	})

	return { lines, unitLines }
}

function prepareMultilineOverlay(state, target) {
	if (!state.lines || state.lines.length <= 1) {
		return false
	}

	const container = state.container
	const cs = window.getComputedStyle(container)
	const targetRect = target.getBoundingClientRect()
	const overlay = document.createElement('span')
	state.originalStyle = {
		backgroundColor: container.style.backgroundColor,
		backgroundImage: container.style.backgroundImage,
		position: container.style.position,
		zIndex: container.style.zIndex,
	}

	overlay.className = OVERLAY_CLASS
	overlay.setAttribute('aria-hidden', 'true')
	overlay.style.position = 'absolute'
	overlay.style.inset = '0'
	overlay.style.display = 'block'
	overlay.style.pointerEvents = 'none'
	overlay.style.overflow = 'visible'
	overlay.style.zIndex = '0'

	state.lines.forEach((line) => {
		const lineOverlay = document.createElement('span')
		line.baseLeft = line.paintLeft - targetRect.left
		line.baseTop = line.paintTop - targetRect.top
		line.fullWidth = Math.max(0, line.paintRight - line.paintLeft)
		line.fullHeight = Math.max(0, line.paintBottom - line.paintTop)
		line.overlay = lineOverlay

		lineOverlay.style.position = 'absolute'
		lineOverlay.style.display = 'block'
		lineOverlay.style.left = line.baseLeft + 'px'
		lineOverlay.style.top = line.baseTop + 'px'
		lineOverlay.style.width = '0px'
		lineOverlay.style.height = line.fullHeight + 'px'
		lineOverlay.style.background = cs.background
		lineOverlay.style.borderRadius = cs.borderRadius
		lineOverlay.style.boxShadow = cs.boxShadow
		lineOverlay.style.opacity = cs.opacity
		overlay.appendChild(lineOverlay)
	})

	target.insertBefore(overlay, target.firstChild)
	state.overlay = overlay
	container.classList.add(REVEAL_CLASS)
	container.setAttribute(REVEAL_ATTR, '1')
	container.style.backgroundColor = 'transparent'
	container.style.backgroundImage = 'none'
	container.style.position = 'relative'
	container.style.zIndex = '1'
	return true
}

function setOverlayLine(line, left, width) {
	if (!line.overlay) {
		return
	}
	line.overlay.style.left = left + 'px'
	line.overlay.style.width = Math.max(0, width) + 'px'
}

function resetStateReveal(state, reverse) {
	if (!state.overlay) {
		resetContainer(state.container, reverse)
		return
	}
	state.lines.forEach((line) => {
		setOverlayLine(line, reverse ? line.baseLeft + line.fullWidth : line.baseLeft, 0)
	})
}

function setOverlayReveal(state, unit, reverse) {
	const currentLine = state.unitLines && state.unitLines.get(unit)
	if (!currentLine) {
		return
	}
	const unitRect = unit.getBoundingClientRect()

	state.lines.forEach((line) => {
		if (reverse) {
			if (line.index > currentLine.index) {
				setOverlayLine(line, line.baseLeft, line.fullWidth)
			} else if (line.index < currentLine.index) {
				setOverlayLine(line, line.baseLeft + line.fullWidth, 0)
			} else {
				const hiddenLeft = Math.max(0, Math.min(line.fullWidth, unitRect.left - line.paddingLeft - line.paintLeft))
				setOverlayLine(line, line.baseLeft + hiddenLeft, line.fullWidth - hiddenLeft)
			}
			return
		}

		if (line.index < currentLine.index) {
			setOverlayLine(line, line.baseLeft, line.fullWidth)
		} else if (line.index > currentLine.index) {
			setOverlayLine(line, line.baseLeft, 0)
		} else {
			const visibleWidth = Math.max(0, Math.min(line.fullWidth, unitRect.right + line.paddingRight - line.paintLeft))
			setOverlayLine(line, line.baseLeft, visibleWidth)
		}
	})
}

function setOverlayFullyVisible(state) {
	state.lines.forEach((line) => {
		setOverlayLine(line, line.baseLeft, line.fullWidth)
	})
}

function setStateReveal(state, unit, reverse) {
	if (state.overlay) {
		setOverlayReveal(state, unit, reverse)
		return
	}
	const containerRect = state.container.getBoundingClientRect()
	if (!containerRect.width) {
		return
	}
	if (reverse) {
		setContainerClip(state.container, 'inset(0 0 0 ' + getUnitLeftInContainer(unit, state.container) + 'px)')
		return
	}
	const hiddenRight = Math.max(0, containerRect.width - getUnitRightInContainer(unit, state.container))
	setContainerClip(state.container, 'inset(0 ' + hiddenRight + 'px 0 0)')
}

export function prepareTypewriterBackgroundReveal(target, units, reverse) {
	const previousState = targetStates.get(target)
	clearState(previousState)

	const unitList = Array.from(units || []).filter((unit) => !!unit)
	const unitIndexes = new Map()
	const states = []
	const seenContainers = new Set()

	unitList.forEach((unit, index) => {
		unitIndexes.set(unit, index)
		if (!unit || !unit.getBoundingClientRect) {
			return
		}
		const container = findBackgroundRevealContainer(unit, target)
		if (!container) {
			return
		}
		let state = states.find((entry) => entry.container === container)
		if (!state) {
			state = {
				container,
				units: [],
				revealedCount: 0,
				reverse: !!reverse,
			}
			states.push(state)
			seenContainers.add(container)
		}
		state.units.push(unit)
	})

	const targetState = {
		containers: Array.from(seenContainers),
		states,
		units: unitList,
		unitIndexes,
		reverse: !!reverse,
		target,
		originalTargetPosition: target.style.position,
		targetPositionChanged: false,
	}

	if (states.length && window.getComputedStyle(target).position === 'static') {
		target.style.position = 'relative'
		targetState.targetPositionChanged = true
	}

	states.forEach((state) => {
		const measuredLines = measureVisualLines(state.units, state.container)
		state.lines = measuredLines.lines
		state.unitLines = measuredLines.unitLines
		if (!prepareMultilineOverlay(state, target)) {
			resetContainer(state.container, reverse)
		}
	})

	targetStates.set(target, targetState)
}

export function revealTypewriterUnitBackground(target, unit) {
	const targetState = targetStates.get(target)
	if (!targetState || !targetState.states) {
		return
	}

	targetState.states.forEach((state) => {
		if (state.units.indexOf(unit) === -1) {
			return
		}
		state.revealedCount += 1
		setStateReveal(state, unit, state.reverse)

		if (state.revealedCount >= state.units.length) {
			if (state.overlay) {
				setOverlayFullyVisible(state)
			} else {
				clearContainerClip(state.container)
			}
		}
	})

	if (
		targetState.targetPositionChanged &&
		targetState.states.every((state) => state.revealedCount >= state.units.length && !state.overlay)
	) {
		target.style.position = targetState.originalTargetPosition
		targetState.targetPositionChanged = false
	}
}

export function setTypewriterBackgroundRevealProgress(target, visibleCount, reverse) {
	const targetState = targetStates.get(target)
	if (!targetState || !targetState.states || !targetState.units) {
		return
	}

	const units = targetState.units
	const total = units.length
	const count = Math.max(0, Math.min(total, visibleCount | 0))
	const isReverse = reverse === undefined ? !!targetState.reverse : !!reverse

	targetState.states.forEach((state) => {
		const visibleUnits = state.units.filter((unit) => {
			const index = targetState.unitIndexes.get(unit)
			if (typeof index !== 'number') {
				return false
			}
			return isReverse ? index >= total - count : index < count
		})
		state.revealedCount = visibleUnits.length

		if (visibleUnits.length === 0) {
			resetStateReveal(state, isReverse)
			return
		}

		if (visibleUnits.length >= state.units.length) {
			if (state.overlay) {
				setOverlayFullyVisible(state)
			} else {
				clearContainerClip(state.container)
			}
			return
		}

		const edgeUnit = isReverse ? visibleUnits[0] : visibleUnits[visibleUnits.length - 1]
		setStateReveal(state, edgeUnit, isReverse)
	})
}

export function clearTypewriterBackgroundReveal(target) {
	const state = targetStates.get(target)
	clearState(state)
	targetStates.delete(target)
}
